import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-race-confirm-weigh-in',
  templateUrl: './race-confirm-weigh-in.component.html',
  styleUrls: ['./race-confirm-weigh-in.component.scss']
})
export class RaceConfirmWeighInComponent implements OnInit {
  @Input() race;
  meta: {
    saving: boolean
  };
  userId: number;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  confirm() {
    this.meta.saving = true;
    const payload = {
      year: this.race.yearOfRace,
      raceId: this.race.raceId,
      divSeq: this.race.divisionSequence,
      updatedBy: this.userId,
      raceWeighedInTime: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    console.log(`[ DEBUG ] Sending payload`, payload);
    this.apiService.updateRace(payload.year, payload.raceId, payload.divSeq, payload).subscribe(
      res => {
        // console.log('[ DEBUG ] Race Weigh-In Saved:', res);
        this.activeModal.close(res);
        this.notification.success(`Race ${this.race.raceTime} Weigh-In Sent.`, 'Race Weigh-In');
      },
      err => {
        console.error('[ DEBUG ] Error updating race weigh-in', err);
        this.notification.error(`Race ${this.race.raceTime} Weigh-In could't be sent. Check your connection and Try again.`, 'Race Weigh-In');
        this.meta.saving = false;
      }
    );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
